import { Component, InjectionToken, Type } from "@angular/core";
import {SoftlineEntityService} from '@softline/core';
import {ProduktionsauftragConfig} from './types/produktionsauftrag-config';

export const SOFTLINE_PERMISSION_PRODUKTIONSAUFTRAG = 'SOFTAPPS.PRODUKTIONSAUFTRAG';

export const SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_QUERY = 'produktionsauftragQuery';
export const SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_BEWEPR = 'produktionsauftragBewepr';
export const SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_BEWEAU = 'produktionsauftragBeweau';
export const SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_FILTER = 'produktionsauftragFilter';

export const SOFTLINE_CONST_PRODUKTIONSAUFTRAG_REZEPTLISTE = 'rezeptliste';
export const SOFTLINE_CONST_PRODUKTIONSAUFTRAG_ZUSATZDATEN = 'zusatzdaten';

export const SOFTLINE_DEFINITION_PRODUKTIONSAUFTRAG_FILTER = 'produktionsauftrag/filter';
export const SOFTLINE_DEFINITION_PRODUKTIONSAUFTRAG_FILTER_EXTENDED = 'produktionsauftrag/filter-extended';

export const SOFTLINE_CONFIG_PRODUKTIONSAUFTRAG =
  new InjectionToken<ProduktionsauftragConfig>('SOFTLINE_CONFIG_PRODUKTIONSAUFTRAG')

export const SOFTLINE_SERVICE_PRODUKTIONSAUFTRAG_REZEPTLISTE =
  new InjectionToken<SoftlineEntityService<any>>('SOFTLINE_SERVICE_PRODUKTIONSAUFTRAG_REZEPTLISTE')
export const SOFTLINE_SERVICE_PRODUKTIONSAUFTRAG_ZUSATZDATEN =
  new InjectionToken<SoftlineEntityService<any>>('SOFTLINE_SERVICE_PRODUKTIONSAUFTRAG_ZUSATZDATEN')

export const SOFTLINE_CONFIG_PRODUKTIONSAUFTRAG_DETAIL_TEMPLATE =
  new InjectionToken<Type<Component>>('SOFTLINE_CONFIG_PRODUKTIONSAUFTRAG_DETAIL_TEMPLATE')
